import { Component, OnInit } from '@angular/core';

import { ApiService } from '../../services/api.service';
import { LoaderComponent } from '../../components/layout/loader/loader.component';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [LoaderComponent, CommonModule, FormsModule],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent implements OnInit {

  item: any = [];
  loading = false;

  passwordUpdated = false;

  public update_password = {
    current_password: "",
    new_password: "",
    new_password_repeat: ""
  }

  public errorMessage: any = false;

  constructor(private apiService: ApiService) { }

  ngOnInit(): void {
    const self = this;

    self.apiService.get("/me").then((data: any) => {
      self.item = data;
    });
  }

  savePassword() {
    this.apiService.post("/office/users/change-password", this.update_password)
      .then(() => {
        this.errorMessage = [];
        this.passwordUpdated = true;
      })
      .catch((err) => {
        const errorObj = err.error?.error || {};
        // Collect all error arrays into one flat array
        this.errorMessage = Object.values(errorObj).flat();
      });
  }
}
